import { render, staticRenderFns } from "./noticeBuilder.vue?vue&type=template&id=650d788c&scoped=true"
import script from "./noticeBuilder.vue?vue&type=script&lang=js"
export * from "./noticeBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650d788c",
  null
  
)

export default component.exports